import React, { useState } from 'react'
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { productAddNew } from '../../../../actions/products';
import { uiCloseModal } from '../../../../actions/ui';
import { ModalSell } from '../SellPanel/ModalSell';
import { ModalUser } from '../usersPanel/ModalUser';
import { ModalAdd } from './ModalAdd';
import { ModalUpdate } from './ModalUpdate';
const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  
  Modal.setAppElement('#root');

export const ProductsModal = () => {

    const dispatch = useDispatch()

   const { modalOpen , item } = useSelector( state => state.ui )



   const closeModal = () => {
    
    dispatch(uiCloseModal())

    }

  return (
        <Modal
            isOpen={ modalOpen }
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            className="modal"
            closeTimeoutMS={200}
            overlayClassName="modal-fondo"
            
        >

        {
            (item.acc && item.precio === undefined)
            &&
            <ModalAdd item={item} closeModal={closeModal}/>
        }
        {
          (item.acc && item.precio )&&
           <ModalUpdate item={item} closeModal={closeModal}/>   
        }
        {
          (item.acces)&&
          <ModalUser user={item} closeModal={closeModal}/>
        }
        {
          (item.tramite)&&
          <ModalSell venta={item} closeModal={closeModal}/>
        }



        </Modal>
  )
}
